/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontFollowButton_seller$ref: FragmentReference;
export type StorefrontFollowButton_seller = {|
  +serviceId: ?string,
  +favoritesByUser?: ?$ReadOnlyArray<?{|
    +serviceId: ?string
  |}>,
  +$refType: StorefrontFollowButton_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "StorefrontFollowButton_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "favoritesByUser",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "Favorite",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f611bf7aab25f961ebcf84d31217e2d9';
module.exports = node;
